import {
  BAR_VARIANT_GROUP,
  BAR_VARIANT_SINGLE,
  BAR_VARIANT_STACK,
  type BarSeriesVariant,
} from '../../../types/xy-chart.js';

export function getBarSeriesVariant(
  canStack: boolean,
  canGroup: boolean,
): BarSeriesVariant {
  if (canStack) {
    return BAR_VARIANT_STACK;
  } else if (canGroup) {
    return BAR_VARIANT_GROUP;
  } else {
    return BAR_VARIANT_SINGLE;
  }
}
